module.exports = __webpack_public_path__ + "assets/b12cc2fbeac67b70d9b9767ac6e7dc23.png";